"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHILD_AGE_GENDER_QUALIFICATION_NAME = exports.CHILD_AGE_GENDER_QUALIFICATION_ID = exports.NO_CHILDREN_CODE = exports.END_CHILDREN_AGE_CODE = exports.START_CHILDREN_AGE_CODE = exports.END_CHILD_AGE_CODE = exports.START_CHILD_AGE_CODE = exports.GENDERS = exports.YEARS = exports.MONTHS = void 0;
/* answer ids goes from 111 to 167
 * from 111 to 132 counts boys and girls ages from 1 to 11 months: baby age
 * from 133 to 166 counts boys and girls ages from 1 to 17 years: child age
 * 167 is a negative response: no children
 * counting alternates each age by starting on boys and ending in girls then go to next age
 */
exports.MONTHS = 48;
exports.YEARS = 17;
exports.GENDERS = 2;
exports.START_CHILD_AGE_CODE = 111;
exports.END_CHILD_AGE_CODE = 233;
exports.START_CHILDREN_AGE_CODE = 133;
exports.END_CHILDREN_AGE_CODE = 166;
exports.NO_CHILDREN_CODE = 167;
exports.CHILD_AGE_GENDER_QUALIFICATION_ID = 232;
exports.CHILD_AGE_GENDER_QUALIFICATION_NAME = 'child_age_gender';
